// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"MySelectAccounts_my_select_wrapper__atJcS","my_select":"MySelectAccounts_my_select__OWgvu"};